var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "page-header navbar" }, [
    _c("div", { staticClass: "page-header-inner container" }, [
      _c(
        "div",
        { staticClass: "page-logo", staticStyle: { "padding-left": "2px" } },
        [
          _c("router-link", { attrs: { to: { name: "home" } } }, [
            _c("img", {
              staticClass: "logo-default",
              attrs: {
                src: require("../assets/global/img/logo.png"),
                alt: "logo"
              }
            })
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c("a", {
        staticClass: "menu-toggler responsive-toggler",
        attrs: {
          href: "javascript:;",
          "data-toggle": "collapse",
          "data-target": ".navbar-collapse"
        }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "top-menu" }, [
        _c("ul", { staticClass: "nav navbar-nav pull-right" }, [
          _c("li", { staticClass: "dropdown dropdown-user" }, [
            _c(
              "a",
              {
                directives: [{ name: "dropdown", rawName: "v-dropdown" }],
                staticClass: "dropdown-toggle",
                attrs: { href: "javascript:;" }
              },
              [
                _vm.loginUser.headImg
                  ? _c("img", {
                      staticClass: "img-circle",
                      staticStyle: { width: "28px", height: "28px" },
                      attrs: { src: _vm.thumb(_vm.loginUser.headImg, 28, 28) }
                    })
                  : _c("img", {
                      staticClass: "img-circle",
                      attrs: {
                        src: require("../assets/layouts/layout/img/avatar3_small.jpg")
                      }
                    }),
                _vm._v(" "),
                _c(
                  "span",
                  { staticClass: "username username-hide-on-mobile" },
                  [
                    _vm._v(
                      " " +
                        _vm._s(_vm.loginUser.nickName || _vm.loginUser.name) +
                        " "
                    )
                  ]
                ),
                _vm._v(" "),
                _c("i", { staticClass: "fa fa-angle-down" })
              ]
            ),
            _vm._v(" "),
            _c("ul", { staticClass: "dropdown-menu dropdown-menu-default" }, [
              _c(
                "li",
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "nav-item",
                      attrs: {
                        to: { name: "profile" },
                        tag: "a",
                        "active-class": "open active"
                      }
                    },
                    [
                      _c("i", { staticClass: "icon-user" }),
                      _vm._v(" 我的信息\n              ")
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("li", [
                _c(
                  "a",
                  {
                    attrs: { href: "javascript:void(0);" },
                    on: {
                      click: function($event) {
                        return _vm.logout()
                      }
                    }
                  },
                  [_c("i", { staticClass: "icon-key" }), _vm._v(" 退出 ")]
                )
              ])
            ])
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }